import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import VueMeta from 'vue-meta'
import excel from 'vue-excel-export'


Vue.config.productionTip = false
Vue.use(VueMeta);
Vue.use(excel)

new Vue({
    router,
    store,
    created() {
        if (localStorage.getItem('user')) {
            this.$store.dispatch('user/autoLoginUser', localStorage.getItem('user'))
        }
        if (localStorage.getItem('userName')) {
            this.$store.dispatch('user/autoUserName', localStorage.getItem('userName'))
        }
    }
    ,
    vuetify,
    render: h => h(App),
}).$mount('#app')




